// module imports
import './modules/toggle-state';
import './modules/wysiwyg';
import './modules/header';
import './modules/popin';
import './modules/popin-form';
import './modules/toggle-state';
import './modules/footer';
// utils imports
import './utils/utils';

// components imports
import '../../port-boulogne-calais/components/components';

// blocks imports
import '../../port-boulogne-calais/blocks/blocks';

// modules imports
import '../../port-boulogne-calais/modules/modules';

// pages imports
import '../../port-boulogne-calais/pages/pages';

document.addEventListener(
	'wpcf7mailsent',
	(event: Event) => {
		const form = event.target as HTMLElement;
		const responseOutput = form.querySelector(
			'.wpcf7-response-output'
		) as HTMLElement | null;
		responseOutput?.scrollIntoView({
			behavior: 'smooth',
			block: 'center',
		});
	},
	false
);

/*
	BEWARE
	when you update the scripts, you need to copy the bundle generated in convert it in babel compiler (https://babeljs.io/repl).
	Than move the transpiled version to application/assets/legacy.js
	the lagacy file is loaded in layout-footer.twig
	This fix is required as far as we support IE11
*/
